export default "__VITE_ASSET__iMjJcSEi__";